// src/data/memberBasis.js
//
// Record 612 (Bob 10/8; ruling 204, agreed - condition 5 met by data\YCP_ANTHROPIC_DATA_TERMS_2026-10-08.md):
// RULE MATCHING FOR A MEMBER, AND THE ONE SENTENCE THAT TRAVELS WITH IT.
//
// Ruling 204: "A member carrying his own claim gets the same rule matching every filer gets - the catalogue offering
// a possible basis - and never an assessment of his claim's strength." functions\analyzeInput.js analyzeRoleAllows()
// lets a member into the catalogue rule-matching mode and nothing else; this module holds the words every
// member-facing suggestion carries, so Quick File, the full form and the rule picker cannot say it three ways
// (directives XI).
//
// PURE. No React, no Firestore.

// Bob's words, 2026-10-08. Fixed: not composed, not shortened, not varied by screen.
export const MEMBER_BASIS_LABEL = 'A possible basis, not advice. Check it with your Local Chair.';

// A member is the account whose role is 'member' and nothing more. An administrator or an officer who happens to
// carry a member claim is not shown the member's label - he is the one a member checks it with.
export function isMemberOnly(user) {
  const u = user || {};
  return !u.isAdmin && u.role === 'member';
}

// The label for this viewer: the fixed sentence for a member, '' for everyone else (render nothing on '').
export function memberBasisLabel(user) {
  return isMemberOnly(user) ? MEMBER_BASIS_LABEL : '';
}
